import { cn } from "@utils/utils"

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
}

const InputField = ({ className, ...inputProps }: InputFieldProps) => {
  return (
    <input
      className={cn("h-12 w-full rounded-lg border border-neutral-30 p-2 text-lg text-on-surface", className)}
      {...inputProps}
    />
  )
}

export default InputField
